import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "className", "activated", "colors", "disabled", "iconLeft", "iconRight", "invert", "withCloseIcon", "subTitle", "onClick", "color"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { withDataConverter } from '@beef/react';
import { compose } from '@beef/utils';
import { Text } from "../Text";
import { MotionComponent } from "../../modules/MotionComponent";
import { ChipsIcon } from "./ChipsIcon";
import styles from "./styles.pcss";
import { dataConverter, getBgColor, getWrappedVariable } from "./utils";
var cnChips = cnBem('chips', styles);
var ChipsRender = function ChipsRender(_ref, ref) {
  var _objectSpread2;
  var label = _ref.label,
    className = _ref.className,
    activated = _ref.activated,
    colors = _ref.colors,
    disabled = _ref.disabled,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    invert = _ref.invert,
    withCloseIcon = _ref.withCloseIcon,
    subTitle = _ref.subTitle,
    onClick = _ref.onClick,
    color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MotionComponent, _extends({}, otherProps, {
    className: cnChips({
      active: activated,
      disabled: disabled,
      invert: invert,
      color: color
    }, [className]),
    onClick: disabled ? undefined : onClick,
    ref: ref,
    style: _objectSpread(_objectSpread({}, otherProps.style), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, '--chips-bg-color', getWrappedVariable(getBgColor(color, activated, disabled, invert), 'background')), _defineProperty(_objectSpread2, '--chips-sub-title-color', getWrappedVariable(colors.subTitle, 'text')), _objectSpread2))
  }), /*#__PURE__*/React.createElement(ChipsIcon, {
    color: colors.icon,
    icon: iconLeft
  }), /*#__PURE__*/React.createElement(Text, {
    className: cnChips('label'),
    color: colors.title,
    tagName: "p",
    variant: "body-small"
  }, label, subTitle && /*#__PURE__*/React.createElement("span", {
    className: cnChips('subTitle')
  }, subTitle)), /*#__PURE__*/React.createElement(ChipsIcon, {
    color: withCloseIcon ? colors.closeIcon : colors.icon,
    icon: withCloseIcon ? IconCloseRoundStroked : iconRight
  }));
};
export var Chips = compose(withDataConverter(dataConverter), forwardRef)(ChipsRender);